import PtIcon from '@patsnap-biz/icon';
import '@patsnap-ui/icon/assets/solid/SearchLeft.svg';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
export default {
    name: 'FieldFilterInput',
    components: {
        PtIcon,
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        value: {
            type: String,
            default: '',
        },
        count: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            focus: false,
        };
    },
    computed: {
        filter: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('change', value);
            },
        },
    },
};
